<template>
  <div :id="unitId" :style="minWidthHeight"></div>
</template>
<script>
import { defineComponent, ref, onMounted, inject } from '@nuxtjs/composition-api';
import { uniqueId } from 'lodash';

export default defineComponent({
  name: 'criteo',
  props: ['cid', 'size'],
  setup(props) {
    const adConfig = inject('adConfig');
    const unitId = ref();
    const minWidthHeight = ref({});
    if (props.size) {
      const [width, height] = props.size.split('x');
      minWidthHeight.value = {
        minWidth: width + 'px',
        minHeight: height + 'px',
      };
    }
    onMounted(() => {
      unitId.value = 'crt-passback-' + uniqueId('uid-');
      const placement = {
        slotid: unitId.value,
        zoneId: parseInt(props.cid),
        mediaTypes: {
          video: {
            context: 'instream',
            placement: 1,
            playerSize: [640, 480],
            mimes: ['video/mp4'],
            protocols: [1, 2, 3],
            api: [1, 2],
            playbackmethod: [2, 3],
            skip: 1,
            startdelay: 0,
            maxduration: 90,
          },
        },
      };
      adConfig.value.criteoArticleUnits.placements.push(placement);
    });
    return { unitId, minWidthHeight };
  },
});
</script>
